<template>
  <section class="step">
    <Navigation name="company"></Navigation>
    <div class="step-body">
      <h1>Company Information</h1>
      <div
        :class="[component.inputDefaultClass, { 'error': component.hasError.Number, 'valid': component.isValid.Number }]">
        <label class="form-label">Company ABN (Australian Business Numbers):</label>
        <Loader v-if="component.activeLoader.value" width="25px" height="25px" view-box="-90 -60 200 300"
          wrapper-class="input-loader"></Loader>
        <input type="text" @change="component.validateNumber" @paste="component.validateNumber"
          @input="component.maskCompanyNumber" v-model="component.fields.Number" placeholder="11 111 111 111"
          minlength="8">
        <!-- <span v-show="!validate.Number" class="error-append">This is not correct.</span> -->
      </div>
      <div :class="[component.inputDefaultClass, { 'error': component.hasError.Name, 'valid': component.isValid.Name }]">
        <label class="form-label">Company Name:</label>
        <input type="text" @input="component.validateName" v-model="component.fields.Name" placeholder="IT&T Wollongong"
          size="40">
        <!-- <span v-show="!validate.Name" class="error-append">This is not correct.</span> -->
      </div>
      <!-- {{ component.isEnabled.value }} -->
      <div id="wizard-action">
        <router-link :to="{ name: 'Plans' }" :class="{ 'prevBtn': true }"> Back</router-link>
        <router-link :to="{ name: 'Contact' }" :class="{ 'nextBtn': true, 'disabled': !component.isEnabled.value }">
          Next</router-link>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import Loader from '../loader/loader.component.vue';
import Navigation from "../layout/navigation.component.vue";
import component from "./company.component";
import { onBeforeRouteLeave, onBeforeRouteUpdate } from 'vue-router';

onBeforeRouteLeave((to) => {
  console.log(to.name);
  if (to.name?.toString().toLowerCase().includes('contact')) {
    component.store();
  }
})
</script>


